<template>
    <div>
        <div v-if="!getMember.participations || !getMember.participations.length>0">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-body">
                            <p>
                                Pas de compétitions pour ce membre
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form role="form" v-if="getMember.participations && getMember.participations.length>0">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <b-col md="9" class="my-1">
                                <h3 class="box-title">Compétitions ({{getMember.participations.length}} compétitions)</h3>
                                <a href=""
                                   :disabled="loadingFicheIndividuelleResultat"
                                   @click.prevent="getFicheIndividuelleResultat()" class="pull-right btn btn-primary">Télécharger la fiche individuelle de résultats</a>

                            </b-col>
                            <b-col md="3" class="my-1">
                                <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
                            </b-col>


                        </div>
                        <div class="box-body">
                            <b-table
                                    id="tableListingStageCompetitions"
                                    responsive bordered striped hover
                                    :items="getMember.participations"
                                    :fields="columns"
                                    :filter="filter"
                                    :current-page="pagination_meta.current_page"
                                    :per-page="pagination_meta.per_page"
                                    :empty-text="'Aucun résultat'"
                                    :empty-filtered-text="'Aucun résultat'"
                                    :sort-compare="sortCompareAdvanced"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    foot-clone
                                    show-empty
                            >

                                <template slot="id" slot-scope="row">
                                    {{ row.item.id | idFormat }}
                                </template>
                                <template slot="competition.date_debut_non_format" slot-scope="data">
                                    {{ formatDate(data.item.competition.date_debut_non_format,'YYYY-MM-DD','DD/MM/YYYY') }}
                                </template>

                                <template slot="competition.competition" slot-scope="row">
                                    <router-link :to="{ name: 'Competition', params: { competition_id: row.item.competition.id }}">
                                        {{ row.item.competition.competition }}
                                    </router-link>

                                </template>
                                <template slot="competition.niveau.niveau" slot-scope="row">
                                    {{ row.item.competition.niveau.niveau }}
                                </template>
                                <template slot="poids.sexe" slot-scope="row">
                                    {{ row.item.poids.sexe == 1 ? "Masculin" : "Féminin" }}
                                </template>

                                <template slot="age.categ_age" slot-scope="row">
                                    {{ row.item.age.categ_age }}
                                </template>
                                <template slot="poids.poids" slot-scope="row">
                                    {{ row.item.poids.poids }}
                                </template>
                                <template slot="grade.categ_grade" slot-scope="row">
                                    {{ row.item.grade.categ_grade }}
                                </template>
                                <template slot="combat_eff" slot-scope="row">
                                    {{ row.item.combat_eff }}
                                </template>

                                <template slot="pointsBonus" slot-scope="row">
                                    {{ row.item.pointsBonus }}
                                </template>
                                <span v-html="get_place(row.item.place)" slot="place" slot-scope="row">
                                </span>

                            </b-table>
                            <b-pagination size="md"
                                          :total-rows="getMember.participations.length"
                                          v-model="pagination_meta.current_page"
                                          :per-page="pagination_meta.per_page">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>


    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import Datepicker from 'vuejs-datepicker';

    var $ = require('jquery');
    var variables = require('../../../assets/js/variables')
    var _ = require('underscore')
    var moment = require('moment')
    var FileSaver = require('file-saver');

    export default {
        data() {
            return {
                sortBy: 'competition.date_debut_non_format',
                sortDesc: true,
                dataTableRankingMember: null,
                filter: null,
                loadingFicheIndividuelleResultat: false,
                pagination_meta: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    path: "",
                    per_page: 20,
                    to: 1,
                    total: 1
                },
                columns: [
                    {
                        label: 'Identifiant',
                        sortable: true,
                        key: 'id'
                    },
                    {
                        label: 'Date',
                        sortable: true,
                        key: 'competition.date_debut_non_format'
                    },
                    {
                        label: 'Compétition',
                        sortable: true,
                        key: 'competition.competition'
                    },
                    {
                        label: 'Niveau',
                        sortable: true,
                        key: 'competition.niveau.niveau'
                    },
                    {
                        label: 'Cat. Sexe',
                        sortable: true,
                        key: 'poids.sexe'
                    },
                    {
                        label: 'Cat. Age',
                        sortable: true,
                        key: 'age.categ_age'
                    },
                    {
                        label: 'Cat. Poids',
                        sortable: true,
                        key: 'poids.poids'
                    },
                    {
                        label: 'Cat. Grade',
                        sortable: true,
                        key: 'grade.categ_grade'
                    },
                    {
                        label: 'Combats Eff.',
                        sortable: true,
                        key: 'combat_eff'
                    },
                    {
                        label: 'Place',
                        sortable: true,
                        key: 'place'
                    },
                    {
                        label: 'Points',
                        sortable: true,
                        key: 'pointsBonus'
                    },
                    {
                        label: 'Action',
                        sortable: true,
                        key: 'action'
                    },
                ]
            }
        },
        computed: {
            ...mapGetters({
                getMember: 'getMember',
                getRoute: 'getRoute',
            }),

        },
        mounted: function () {
            var these = this

        },
        created() {
        },
        watch: {},
        components: {},
        methods: {
            ...mapActions({}),
            flatten: function (obj) {
                var root = {};
                (function tree(obj, index) {
                    var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
                    for (var key in obj) {
                        if (!obj.hasOwnProperty(key)) continue;
                        root[index + key + suffix] = obj[key];
                        if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
                        if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
                    }
                })(obj, "");
                return root;
            },
            sortCompareAdvanced: function (a, b, key) {
                if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                    // If both compared fields are native numbers
                    return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
                } else {
                    // Stringify the field data and use String.localeCompare
                    return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
                        numeric: true
                    })
                }
            },
            getFicheIndividuelleResultat: function () {
                let self = this;
                this.loadingFicheIndividuelleResultat = true
                this.$http.post
                (
                    self.getRoute('Statistiques.exportFicheIndividuelleResultat'),
                    JSON.stringify({
                        "ids_fighter": [this.getMember.id]
                    }),
                    {responseType: 'blob'}
                ).then((response) => {
                    this.loadingFicheIndividuelleResultat = false
                    var blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
                    FileSaver.saveAs(blob, "FicheIndividuelle_" + this.getMember.fullName + ".xlsx");
                    return response.blob();
                }, (response) => {
                    self.$noty.error("Erreur dans la génération du fichier ")
                    this.loadingFicheIndividuelleResultat = false
                });
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
            get_place: function (numero) {
                if (numero == 1)
                    return "1<sup>er</sup>";
                else (numero >= 2)
                return numero + "<sup>ème</sup>";
            }
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/ListingCompetitions.vue